<template>
  <auth-page>
    <div slot="content">
      <form @submit="login()">
        <h1 class="title is-3">Inloggen</h1>
        <b-field label="Gebruikersnaam of e-mail">
          <b-input @keyup.enter.native="login()" v-model="user.username"></b-input>
        </b-field>
        <b-field class="mb-0" label="Wachtwoord">
          <b-input @keyup.enter.native="login()" type="password" v-model="user.password"></b-input>
        </b-field>
        <router-link id="forgot-password" to="/requestpassword">Wachtwoord vergeten?</router-link>
      </form>
      <div class="mt-6 is-flex is-align-items-center is-justify-content-space-between">
        <router-link class="color-dark has-text-weight-bold" to="/aanmelden">Ik heb nog geen account</router-link>
        <b-button @click="login()" class="is-pulled-right" type="is-info">Inloggen</b-button>
      </div>
      <hr />
      <div class="columns social-buttons is-marginless">
        <div class="column">
          <button class="button is-fullwidth" @click="loginWithSocial('google')" expanded>
            <img class="mr-2 social-icon" src="../assets/google-logo.svg" />
            Google
          </button>
        </div>
        <div class="column">
          <button class="button is-fullwidth" @click="loginWithSocial('discord')" expanded>
            <img class="mr-2 social-icon" src="../assets/discord-logo.svg" />
            Discord
          </button>
        </div>
      </div>
    </div>
  </auth-page>
</template>

<script>
import AuthPage from "../components/AuthPage.vue"
import { USER_LOGIN, USER_LOGOUT, USER_UPDATE } from "@/store/User/action.type"
import ApiService from "../common/api.service"

export default {
  name: "Login",
  components: {
    AuthPage,
  },
  data() {
    return {
      user: {
        username: "",
        password: "",
      },
    }
  },
  mounted() {
    this.$store.dispatch(USER_LOGOUT)

    $cookies.remove("token")
  },
  methods: {
    async loginWithSocial(social) {
      this.$buefy.loading.open
      this.$gtag.event("login", { event_category: "auth", event_label: social, value: 1 })
      window.location.href = process.env.VUE_APP_API + "/auth/" + social
    },
    async login() {
      let result = await this.$store.dispatch(USER_LOGIN, this.user)
      if (!result) {
        return this.$buefy.toast.open({
          indefinite: true,
          message: "Verkeerde inloggegevens",
          type: "is-danger",
        })
      }

      this.$buefy.toast.open({
        message: "Je bent succesvol ingelogd",
        type: "is-success",
      })

      this.$gtag.event("login", { event_category: "user", value: 1 })

      //Update user to get initial data
      await this.$store.dispatch(USER_UPDATE, this.user)

      if (!this.$store.state.user.updatedEd) {
        return this.$router.push("/education")
      } else if (this.$route.query.from) {
        window.location.href = this.$route.query.from
      } else {
        window.location.href = process.env.VUE_APP_WORDS
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.social-icon {
  max-height: 15px;
}
.social-buttons {
  .column {
    padding: 5px 5px 0 5px;
    @media only screen and (min-width: 769px) {
      &:first-child {
        padding-left: 0 !important;
      }
      &:last-child {
        padding-right: 0 !important;
      }
    }
  }
}
</style>
